import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c("template", { slot: "description" }, [
            _vm._v(
              " Gestión de accesos de usuarios por región para los indicadores regionales Somos1 V2. "
            ),
          ]),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onOpenAddDialog },
                },
                [
                  _c(VIcon, { attrs: { small: "", left: "" } }, [
                    _vm._v("mdi-plus"),
                  ]),
                  _vm._v(" Agregar acceso "),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(" Filtrar "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _c(
              VCard,
              [
                _c(VDataTable, {
                  key: _vm.keyTable,
                  staticClass: "text-center table-inca",
                  attrs: {
                    items: _vm.filteredItems,
                    headers: _vm.headers,
                    loading: _vm.loadingTable,
                    "hide-default-footer": "",
                    "disable-pagination": "",
                    responsive: "",
                    hover: "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.regiones",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            "div",
                            { staticClass: "py-1" },
                            _vm._l(item.regiones, function (r) {
                              return _c(
                                VChip,
                                {
                                  key: r.id_user_region_access,
                                  staticClass: "mr-1 mb-1",
                                  attrs: { small: "" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.regionName(r.id_region)) +
                                      " "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.actions",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onOpenEditDialog(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [_c(VIcon, [_vm._v("icon-edit")])],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v("Editar regiones del usuario"),
                              ]),
                            ]
                          ),
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onOpenDeleteDialog(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(VIcon, [
                                              _vm._v("icon-delete"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Eliminar todos los accesos del usuario"
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VForm,
                  {
                    ref: "form",
                    staticClass: "form",
                    attrs: { "lazy-validation": "" },
                  },
                  [
                    _c(
                      VCard,
                      { staticClass: "filters-inca" },
                      [
                        _c(
                          VCardTitle,
                          {
                            staticClass: "pointer",
                            on: {
                              click: function ($event) {
                                _vm.collapse_filter = !_vm.collapse_filter
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("titles.search_filters")) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          VCardText,
                          { staticClass: "pa-2 pt-0" },
                          [
                            _c(
                              VRow,
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  VCol,
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(VTextField, {
                                      attrs: {
                                        "append-icon": "mdi-magnify",
                                        label: "Buscar por email",
                                        "single-line": "",
                                        "hide-details": "",
                                        dense: "",
                                        outlined: "",
                                      },
                                      model: {
                                        value: _vm.search,
                                        callback: function ($$v) {
                                          _vm.search = $$v
                                        },
                                        expression: "search",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(VSelect, {
                                      attrs: {
                                        label: "Región",
                                        items: _vm.allRegions,
                                        "item-text": "name",
                                        "item-value": "id_region",
                                        dense: "",
                                        outlined: "",
                                        "hide-details": "",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.filterRegion,
                                        callback: function ($$v) {
                                          _vm.filterRegion = $$v
                                        },
                                        expression: "filterRegion",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-md-12 text-right" },
                                  [
                                    _c(
                                      VBtn,
                                      {
                                        staticClass: "default",
                                        attrs: { outlined: "" },
                                        on: { click: _vm.onLimpiar },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("btns.clean")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("dialogs-component", {
        ref: _vm.DIALOG_ADD,
        attrs: { title: "Agregar acceso de región", width: 500 },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VForm,
                  { ref: "formAdd", attrs: { "lazy-validation": "" } },
                  [
                    _c(
                      VRow,
                      { attrs: { dense: "" } },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "12" } },
                          [
                            _c(VTextField, {
                              attrs: {
                                label: "Email del usuario",
                                outlined: "",
                                dense: "",
                                "hide-details": "auto",
                                rules: _vm.emailRules,
                              },
                              model: {
                                value: _vm.form.email,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "email", $$v)
                                },
                                expression: "form.email",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { staticClass: "mt-3", attrs: { cols: "12" } },
                          [
                            _c(VSelect, {
                              attrs: {
                                label: "Regiones",
                                items: _vm.allRegions,
                                "item-text": "name",
                                "item-value": "id_region",
                                outlined: "",
                                dense: "",
                                "hide-details": "auto",
                                multiple: "",
                                chips: "",
                                "small-chips": "",
                                "deletable-chips": "",
                                rules: [
                                  function (v) {
                                    return (
                                      (v && v.length > 0) ||
                                      "Selecciona al menos una región"
                                    )
                                  },
                                ],
                              },
                              model: {
                                value: _vm.form.id_regions,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "id_regions", $$v)
                                },
                                expression: "form.id_regions",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: { click: _vm.onSubmitAdd },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" Agregar "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_EDIT,
        attrs: { title: "Editar regiones del usuario", width: 500 },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VForm,
                  { ref: "formEdit", attrs: { "lazy-validation": "" } },
                  [
                    _c(
                      VRow,
                      { attrs: { dense: "" } },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "12" } },
                          [
                            _c(VTextField, {
                              attrs: {
                                value: _vm.form.email,
                                label: "Email del usuario",
                                outlined: "",
                                dense: "",
                                "hide-details": "auto",
                                readonly: "",
                                disabled: "",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { staticClass: "mt-3", attrs: { cols: "12" } },
                          [
                            _c(VSelect, {
                              attrs: {
                                label: "Regiones",
                                items: _vm.allRegions,
                                "item-text": "name",
                                "item-value": "id_region",
                                outlined: "",
                                dense: "",
                                "hide-details": "auto",
                                multiple: "",
                                chips: "",
                                "small-chips": "",
                                "deletable-chips": "",
                                rules: [
                                  function (v) {
                                    return (
                                      (v && v.length > 0) ||
                                      "Selecciona al menos una región"
                                    )
                                  },
                                ],
                              },
                              model: {
                                value: _vm.form.id_regions,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "id_regions", $$v)
                                },
                                expression: "form.id_regions",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: { click: _vm.onSubmitEdit },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" Guardar "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_DELETE,
        attrs: { title: "Confirmar eliminación" },
        on: { onConfirm: _vm.onConfirmDelete },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }